/* Consenso al recesso sui contenuti digitali (art. 59 Cod. Consumo)
   Inserisce una casella obbligatoria sopra il pulsante di pagamento,
   blocca il checkout finche non e spuntata e registra il consenso
   come attributo dell'ordine, cosi resta scritto nel pannello Shopify. */
(function () {
  'use strict';

  var TESTO =
    'Chiedo l’accesso immediato al file e accetto di perdere il diritto di recesso una volta iniziato il download. ' +
    'Ho letto le <a href="/pages/condizioni-di-vendita" target="_blank" rel="noopener">condizioni di vendita</a>.';

  var AVVISO = 'Per procedere devi accettare le condizioni qui sopra.';
  var ID = 'consenso-recesso';
  var accettato = false;

  function stile() {
    if (document.getElementById('consenso-recesso-stile')) return;
    var s = document.createElement('style');
    s.id = 'consenso-recesso-stile';
    s.textContent =
      '.consenso-box{display:flex;gap:10px;align-items:flex-start;margin:0 0 14px;padding:14px 16px;' +
      'background:#F2F1ED;border:1px solid #DEDCD6;border-left:3px solid #DC4B22;font-size:14px;line-height:1.45;color:#14161A;text-align:left}' +
      '.consenso-box input{width:18px;height:18px;flex:none;margin-top:1px;accent-color:#DC4B22;cursor:pointer}' +
      '.consenso-box label{cursor:pointer}' +
      '.consenso-box a{color:#DC4B22;text-underline-offset:.2em}' +
      '.consenso-box.errore{border-color:#DC4B22;background:#FBEAE4}' +
      '.consenso-avviso{display:none;font-size:13.5px;color:#A8330E;font-weight:600;margin:-8px 0 12px}' +
      '.consenso-avviso.visibile{display:block}' +
      '.consenso-bloccato{opacity:.45;pointer-events:none}';
    document.head.appendChild(s);
  }

  function registra() {
    try {
      var ora = new Date().toISOString();
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Consenso recesso contenuti digitali': 'Accettato il ' + ora
          }
        })
      });
    } catch (e) {}
  }

  function blocca(bottone, stato) {
    if (!bottone) return;
    if (stato) {
      bottone.setAttribute('aria-disabled', 'true');
      bottone.classList.add('consenso-bloccato');
    } else {
      bottone.removeAttribute('aria-disabled');
      bottone.classList.remove('consenso-bloccato');
    }
  }

  function monta(bottone) {
    if (!bottone || bottone.dataset.consensoPronto === '1') return;
    bottone.dataset.consensoPronto = '1';

    var box = document.createElement('div');
    box.className = 'consenso-box';
    var uid = ID + '-' + Math.random().toString(36).slice(2, 8);
    box.innerHTML =
      '<input type="checkbox" id="' + uid + '"><label for="' + uid + '">' + TESTO + '</label>';

    var avviso = document.createElement('p');
    avviso.className = 'consenso-avviso';
    avviso.textContent = AVVISO;

    var punto = bottone.closest('.shopify-payment-button') || bottone;
    var contenitore = punto.parentNode;
    if (!contenitore) return;
    contenitore.insertBefore(box, punto);
    contenitore.insertBefore(avviso, punto);

    var casella = box.querySelector('input');
    casella.checked = accettato;
    blocca(bottone, !accettato);

    casella.addEventListener('change', function () {
      accettato = casella.checked;
      blocca(bottone, !accettato);
      box.classList.remove('errore');
      avviso.classList.remove('visibile');
      if (accettato) registra();
      document.querySelectorAll('.consenso-box input').forEach(function (altra) {
        if (altra !== casella) altra.checked = accettato;
      });
    });

    bottone.addEventListener(
      'click',
      function (ev) {
        if (!accettato) {
          ev.preventDefault();
          ev.stopPropagation();
          box.classList.add('errore');
          avviso.classList.add('visibile');
          casella.focus();
        }
      },
      true
    );
  }

  function cerca() {
    stile();
    var selettori = [
      'button[name="checkout"]',
      'input[name="checkout"]',
      'a[href="/checkout"]',
      '.shopify-payment-button__button'
    ];
    document.querySelectorAll(selettori.join(',')).forEach(monta);
  }

  function avvia() {
    cerca();
    var osservatore = new MutationObserver(function () {
      cerca();
    });
    osservatore.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:updated', cerca);
    document.addEventListener('cart:refresh', cerca);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
